<template>
  <b-link :to="to" class="dashboard-card-link">
    <b-card no-body class="dashboard-card">
      <b-card-body class="pb-0">
        <b-avatar class="mb-1" :variant="variant" size="45">
          <template v-if="iconType === 'feather'">
            <feather-icon size="21" :icon="icon" />
          </template>
          <template v-else>
            <i :class="icon" style="font-size: 18px"></i>
          </template>
        </b-avatar>
        <div class="truncate mb-2">
          <h2 class="mb-25 font-weight-bolder">
            {{ value }}
          </h2>
          <span>{{ $t(label) }}</span>
        </div>
      </b-card-body>
    </b-card>
  </b-link>
</template>

<script>
import { BLink, BCard, BCardBody, BAvatar } from "bootstrap-vue";

export default {
  name: "DashboardCard",
  components: { BLink, BCard, BCardBody, BAvatar },
  props: {
    to: { type: String, default: "#" },
    value: { type: [Number, String], required: true },
    label: { type: String, required: true },
    icon: { type: String, required: true },
    iconType: { type: String, default: "feather" },
    variant: { type: String, default: "light-primary" },
  },
};
</script>

<style scoped>
.dashboard-card-link {
  text-decoration: none;
  color: inherit;
}
.dashboard-card {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;
}
.dashboard-card:hover {
  transform: translateY(-5px) scale(1.02);
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.15);
}
</style>
